import React from 'react';
import { motion } from 'framer-motion';
import './wave.css';

const WaveAnimation: React.FC = () => {
	return (
		<div className="wave-wrapper">
			<svg className="wave" viewBox="0 0 480 270" xmlns="http://www.w3.org/2000/svg">
				<defs>
					<linearGradient id="waveGradient" x1="0" y1="0" x2="1" y2="0">
						<stop offset="2%" stopColor="#ddd" stopOpacity="0.9" />
						<stop offset="97%" stopColor="#000" stopOpacity="0.9" />
					</linearGradient>
				</defs>
				<motion.path
					className="wave-path"
					fill="url(#waveGradient)"
					animate={{
						d: [
							'M0,100 Q87.5,40 165,100 T350,90 V400 H0 Z',
							'M0,100 Q87.5,120 165,100 T350,90 V400 H0 Z',
							'M0,100 Q87.5,60 165,100 T350,90 V400 H0 Z',
							'M0,100 Q87.5,110 165,100 T350,90 V400 H0 Z',
							'M0,100 Q87.9,40 165,100 T350,90 V400 H0 Z'
						]
					}}
					transition={{
						repeat: Infinity,
						repeatType: 'reverse',
						duration: 8,
						ease: 'easeInOut'
					}}
				/>
			</svg>
		</div>
	);
};

export default WaveAnimation;
